module.exports = __webpack_public_path__ + "static/img/yushuaqi.9edd5253.svg";